<app-data-table
  [columns]="columns"
  [data]="tableRows"
  emptyMessage="No records for the selected filters.">
  <ng-template appColumnCell="studentName" let-row>
    {{ row.studentFirstName }} {{ row.studentLastName }}
  </ng-template>
</app-data-table>
